"use client";

import FaqSection from "@/components/sections/products/shared/faq";
import RelatedContent from "@/components/sections/tools/shared/related-content";
import { MCP_FAQS } from "./content";
import {
  McpCta,
  McpFeatureGrid,
  McpHero,
  McpIntro,
  McpQuickStart,
  McpToolCategories,
} from "./parts";

const MCP_BLOG_LINKS = [
  { label: "Web Crawling for AI Training Data at Scale", href: "/blog/web-crawling-for-ai" },
  { label: "What is LLM Training Data", href: "/blog/llm-training-data" },
];

const MCP_USE_CASE_LINKS = [{ label: "AI & LLM Training", href: "/use-cases/ai-llm-training/" }];

interface Props {
  npmDownloads?: number | null;
}

export default function McpLanding({ npmDownloads }: Props) {
  return (
    /* No overflow clip here: the banded sections use `.full-bleed`, whose
       negative margins have to escape the shell's max-w-7xl frame to reach the
       viewport edges. html/body already carry overflow-x: clip, so 50vw stays
       scroll-safe — the hero section keeps its own clip for the glow. */
    <main id="main-content" tabIndex={-1} className="relative">
      <McpHero npmDownloads={npmDownloads} />
      <McpIntro />
      <McpFeatureGrid />
      <McpToolCategories />
      <McpQuickStart />
      <RelatedContent
        fromPage="tools/mcp-server"
        blogLinks={MCP_BLOG_LINKS}
        useCaseLinks={MCP_USE_CASE_LINKS}
      />
      <FaqSection
        faqs={MCP_FAQS}
        description="Quick answers about installing and using the Proxidize MCP server."
        headingId="mcp-faq-heading"
      />
      <McpCta />
    </main>
  );
}
